import React from 'react';
import moment from 'moment';

function ScheduleStop({
  data, isLast = false, stationsMap,
}) {
  return (
    <>
      <div className="flex flex-col gap-1 ">
        <p
          className="text-base m-0 whitespace-nowrap capitalize"
        >
          {
            stationsMap.get(data?.station?.code)
            || data?.station?.name
          }
        </p>
        <p
          className="text-base m-0 whitespace-nowrap"
        >
          {
                moment(data?.arrivalDateTime).format('HH:mm')
            }
        </p>
      </div>
      {!isLast && <p className="m-0 text-base">-</p>}
    </>
  );
}

export default ScheduleStop;
